"use client";
import withAuth from "@ctv/core/auth/withAuth";
import { Locale, useLocale } from "@ctv/shared-core/src";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default withAuth(function Page() {
  const router = useRouter();
  const { locale } = useLocale();

  useEffect(() => {
    let fallbackLocale = "en-id";
    if (Object.values(Locale).includes(locale)) {
      fallbackLocale = locale;
    }
    router.push(`/${fallbackLocale}/home`);
  }, []);
  return null;
});
